'use client';

import type { ProductCardProps } from '@skin-seoul/shared-components';
import { VerticalProductCard } from '@skin-seoul/shared-components';
import React from 'react';
import DirectAddToCart from './DirectAddToCart';
import MobileAIChoiceProductCardSkeleton from './MobileAIChoiceProductCard.skeleton';
import { SafeLink } from '@/components/ui/SafeLink';
type AIChoiceProductCardProps = ProductCardProps & {
  isSelected: boolean;
  onTrackAddToCart?: () => void;
};
const MobileAIChoiceProductCard = ({
  isSelected,
  onTrackAddToCart,
  onClick,
  ...cardProps
}: AIChoiceProductCardProps) => {
  return <VerticalProductCard onClick={onClick} {...cardProps} linkComponent={SafeLink} backgroundColor="primary.75" border="1px solid" borderColor={isSelected ? 'primary.300' : 'transparent'} borderRadius="12px" p={3} data-sentry-element="VerticalProductCard" data-sentry-component="MobileAIChoiceProductCard" data-sentry-source-file="MobileAIChoiceProductCard.tsx">
      <VerticalProductCard.Image height="170px" background="generic.0" bottomSlot={<DirectAddToCart sku={cardProps.sku} onTrackAddToCart={onTrackAddToCart} mx={{
      base: 1,
      tablet: 2
    }} marginBottom={{
      base: 1,
      tablet: 2
    }} />} data-sentry-element="VerticalProductCard.Image" data-sentry-source-file="MobileAIChoiceProductCard.tsx" />
      <VerticalProductCard.Content data-sentry-element="VerticalProductCard.Content" data-sentry-source-file="MobileAIChoiceProductCard.tsx">
        <VerticalProductCard.InfoName data-sentry-element="VerticalProductCard.InfoName" data-sentry-source-file="MobileAIChoiceProductCard.tsx" />
        <VerticalProductCard.InfoRating data-sentry-element="VerticalProductCard.InfoRating" data-sentry-source-file="MobileAIChoiceProductCard.tsx" />
      </VerticalProductCard.Content>
    </VerticalProductCard>;
};
MobileAIChoiceProductCard.Skeleton = MobileAIChoiceProductCardSkeleton;
export default MobileAIChoiceProductCard;